import React, { useEffect, useState } from 'react';
import { HeroSection, ProblemSection, FailedApproaches } from '../components/Sections1';
import { UniqueMechanism, WhatYouGet, WhoIsFor } from '../components/Sections2';
import { HowItWorks, ProofSection, FAQSection, FinalOffer } from '../components/Sections3';
import { SectionDivider, CTAButton } from '../components/Shared';
import { PurchaseBanner } from '../components/PurchaseBanner';
import { AnimatePresence, motion } from 'framer-motion';
export const LandingPage = () => {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-dark text-white font-inter selection:bg-gold selection:text-dark" data-id="element-138">
      <main data-id="element-139">
        <HeroSection data-id="element-140" />
        <SectionDivider data-id="element-141" />
        <ProblemSection data-id="element-142" />
        <FailedApproaches data-id="element-143" />
        <UniqueMechanism data-id="element-144" />
        <WhatYouGet data-id="element-145" />
        <WhoIsFor data-id="element-146" />
        <SectionDivider data-id="element-147" />
        <HowItWorks data-id="element-148" />
        <ProofSection data-id="element-149" />
        <FAQSection data-id="element-150" />
        <FinalOffer data-id="element-151" />
      </main>

      <footer className="py-5 md:py-8 pb-20 md:pb-8 text-center border-t border-dark-border bg-black" data-id="element-152">
        <p className="font-inter text-gray-500 text-sm" data-id="element-153">
          © {new Date().getFullYear()} El Método Acento Prohibido. Todos los
          derechos reservados.
        </p>
      </footer>

      <PurchaseBanner data-id="element-154" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-155">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-3 bg-black/90 backdrop-blur-md border-t border-gold/20 z-50 md:hidden" data-id="element-156">
            <CTAButton className="w-full py-3 text-base shadow-lg shadow-gold/20" data-id="element-157" />
          </motion.div>}
      </AnimatePresence>
    </div>;
};